<template>
	<!--div>
		Wrapper: {{ this.manufactor }}

		<hr />

		<select v-model="this.manufactor" >
			<option value="">Välj tillverkare</option>
			<option v-for="(manufactor, index) in baseManufactorList" :key="index" :value="manufactor">{{
				manufactor.name }}</option>
		</select>

		<hr />

		<SelectManufactor :baseManufactorList="this.baseManufactorList" :manufactor="this.manufactor"
			@manufactorSelected="(manufactor) => this.manufactor = manufactor" />
	</div-->
	<SelectManufactor :baseManufactorList="this.baseManufactorList" :manufactor="this.manufactor"
		@manufactorSelected="(manufactor) => this.manufactor = manufactor" style="z-index:8;" />

</template>
<script>
import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
import { STORE_GETTER } from '@/store/store';
export default {
	name: "SelectManufactorWrapper",
	components: { SelectManufactor },
	mixins: [],
	data() {
		return {
			manufactor: null,
		};
	},
	computed: {

		/*baseManufactorList() {
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];



			if (baseModel && baseModel.manufactorList) {
				console.log('FP: baseManufactorList: ', baseModel.manufactorList);
					
					return baseModel.manufactorList
				
			}

			return null;
		},*/

		baseManufactorList() {
			return this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];
		},
	},
};
</script>

